import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { PictureOutlined } from "@ant-design/icons"

//------------------------------------------------------------------------------

function ImageUploadInput(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------
  const { image, onUpload } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [preview, setPreview] = useState(null)

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleUploadChange(event) {
    event.preventDefault()

    const reader = new FileReader()
    const file = event.target.files[0]

    if (file) {
      reader.onloadend = () => {
        setPreview(reader.result)

        onUpload && onUpload(file)
      }

      reader.readAsDataURL(file)
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const currentImage = preview || image

  const imgStyle = {
    backgroundImage: `url(${currentImage})`,
  }

  return (
    <div className={props.className} style={{ ...imgStyle }}>
      <input type="file" accept="image/*" onChange={handleUploadChange} />

      {!currentImage && <PictureOutlined className="placeholder-icn" />}
    </div>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

ImageUploadInput.propTypes = {
  className: PropTypes.string.isRequired,
  image: PropTypes.any,
  onUpload: PropTypes.func,
}

ImageUploadInput.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledImageUploadInput = styled(ImageUploadInput)`
  & {
    position: relative;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 200px;

    border-radius: 4px;
    background-color: ${(props) =>
      props.theme.colors.hoveredTertiaryBackgroundColor};

    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;

    cursor: pointer;

    transition: all 0.2s ease-in-out;

    :hover {
      background-color: ${(props) =>
        props.theme.colors.tertiaryBackgroundColor};
    }

    > input[type="file"] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;

      cursor: pointer;
    }

    .placeholder-icn {
      font-size: 40px;
      color: ${(props) => props.theme.colors.textSecondaryColor};
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledImageUploadInput
